export const UserInfoRouting = {
  path: "/userinfo",
  name: "userinfo",
  meta: { title: "个人信息" },
  component: () => import(/* webpackChunkName: "login" */ "@/views/user-info/index.vue"),
};
